import { render, staticRenderFns } from "./ScreenList.vue?vue&type=template&id=506abab6&scoped=true&"
import script from "./ScreenList.vue?vue&type=script&lang=ts&"
export * from "./ScreenList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506abab6",
  null
  
)

export default component.exports